import PropTypes from 'prop-types'
import React from 'react'

const AddIcon = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 3V21M21 12L3 12"
      stroke="inherit"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

AddIcon.defaultProps = {
  className: '',
}

AddIcon.propTypes = {
  className: PropTypes.string,
}

export default AddIcon
